import settings from '@/constants/constants';
import { usePatientOnboardingDetails } from '@/hooks/usePatientOnboardingDetails';
import { Navigate } from 'react-router-dom';
import { PageWrapper } from '../components/Branding.styles';
import Calendar from '../components/Calendar';

export const ScheduleDoctorConsult = () => {
  const { patientOnboardingDetails } = usePatientOnboardingDetails();

  if (!patientOnboardingDetails) {
    return <Navigate to="/error" />;
  }

  return (
    <PageWrapper>
      <Calendar
        showCalendar
        emailAddress={patientOnboardingDetails.email}
        phoneNumber={patientOnboardingDetails.phoneNumber}
        name={`${patientOnboardingDetails.firstName} ${patientOnboardingDetails.lastName}`}
        calendarLink={`${settings.calendar.calLinkD2D}?intakeVariant=D2D`}
        submitBookingEventLabel="Initial D2D Consultation"
        hidePreConsultFormStep
      />
    </PageWrapper>
  );
};
